module.exports = __webpack_public_path__ + "img/logo.98c3ce2e.jpeg";